import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Form, Button, Label, Icon, Header} from 'semantic-ui-react'

import Utils from 'utils/Utils.js';
import {getUserProfileWithDefaults} from 'reducers/user.js';
import SurveyButtons from './SurveyButtons.js';
import {colors, spacings} from 'style';
import styleDef from './style.js';
import Welcome from 'modules/onboarding/Welcome.js';

var style = {
    ...styleDef,
    image: {
        marginTop: spacings.base,
        marginBottom: spacings.base,
        marginLeft: 'auto',
        marginRight: 'auto',
        height:'300px', 
    },
}

const SurveyPageCompanyWelcome = ({t, 
                         surveyPage, 
                         inlineButtons, 
                         onSubmit, 
                         onSkip, 
                         pageNum, 
                         numPages,
                         userProfile}) => (
        <Welcome //userProfile={userProfile}
                 title={surveyPage.title}
                 welcome={surveyPage.data || {}}
                 buttonLabel={surveyPage.buttonLabel || t('Continue')}
                 next={() => onSubmit()}  />
);

const mapStateToProps = (state, ownProps) => {
    return { userProfile:getUserProfileWithDefaults(state.user) };
}

export default connect(mapStateToProps)(translate('surveys')(SurveyPageCompanyWelcome));



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageCompanyWelcome.js